<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="padding-bottom: 20px;">
                <div class="page-name" style="font-size: 26px; font-weight: bold;">Consolidated QC checklist</div>
            </div>
            <div class="admin-page-content" style="margin-left: 20px;">
                <strong style="display:block;margin-bottom:15px;">
                    Vehicle Servicing / Maintenance, check/complete the following
                </strong>
                <ul style="padding-left:15px;">
                    <li>
                        Service Sheet is complete with all requirements filled out in full
                    </li>
                    <li>
                        Onboard maintenance requirements reviewed and intervals reset (if equipped)
                    </li>
                    <li>
                        Brake and tyre wear values reviewed and measurements recorded
                    </li>
                    <li>
                        Vehicle defect list reported and urgency of safety related concerns highlighted
                    </li>
                    <li>
                        Turntable jaw and mounting fasteners have been adjusted/inspected
                    </li>
                    <li>
                        Service sticker installed (filled out with correct kms & date, clean and positioned correctly)
                    </li>
                </ul>
                <strong style="display:block;margin-bottom:15px;">
                    Brake Maintenance & Repairs, check/complete the following:
                </strong>
                <ul style="padding-left:15px;">
                    <li>
                        Disc brakes: Visually inspect fitment of new pads and pad securing circlip, ensuring correct installation orientation (sealant may be applied to circlip to prevent dislodging)
                    </li>
                    <li>
                        Wheel nuts tensioned to required torque setting
                    </li>
                    <li>
                        Brake wear values reset in maintenance system on applicable vehicle
                    </li>
                    <li>
                        Brake roller test completed post repair and reviewed by supervisor (review results for correct wheel bearing, brake adjustment and function)
                    </li>
                    <li>
                        Perform short road-test, inspect hub temperatures and visually inspect for oil or air leaks
                    </li>
                </ul>
                <strong style="display:block;margin-bottom:15px;">
                    Tail Shaft Fitment, check/complete the following:
                </strong>
                <ul style="padding-left:15px;">
                    <li>
                        Tail shaft visually inspected and free of damage or impact
                    </li>
                    <li>
                        Flange connections cleaned to ensure positive mating surfaces
                    </li>
                    <li>
                        Shaft is in-phase and if the slip joint was separated, that it is clean and lubricated prior to fitment
                    </li>
                    <li>
                        Tail shaft fastening inspected to be serviceable (note: recommended Freightliner “Spicer” universal joint fasteners are single use)
                    </li>
                    <li>
                        Fasteners installed to manufacturer’s specified torque utilising calibrated tension wrench
                    </li>
                    <li>
                        Perform short road-test, monitoring for driveline vibration
                    </li>
                    <li>
                        After road-test, fasteners should re-torqued and movement detection paint applied to bolt heads as completion indicator
                    </li>
                </ul>
                <strong style="display:block;margin-bottom:15px;">
                    Cooling System Repairs, check/complete the following:
                </strong>
                <ul style="padding-left:15px;">
                    <li>
                        CAUTION: Be careful opening cooling system when circuit is at increased temperature
                    </li>
                    <li>
                        Coolant type is correct and tested in serviceable condition
                    </li>
                    <li>
                        Coolant bleed procedure completed with no level warnings displayed on dash
                    </li>
                    <li>
                        Cooling system maintenance has been updated (if equipped with on-board maintenance system)
                    </li>
                    <li>
                        Coolant circuit integrity checked post-repair via pressure test or by increasing system to operating temperature
                    </li>
                    <li>
                        If repair required cooling system temperature increase, ensure top and bottom hose temperature checked to confirm coolant flow
                    </li>
                </ul>
                <strong style="display:block;margin-bottom:15px;">
                    Engine Tune Up, check/complete the following:
                </strong>
                <ul style="padding-left:15px;">
                    <li>
                        Engine tune-up procedure completed by competent technician who has been trained on specific engine variant
                    </li>
                    <li>
                        All adjustment and rocker gear securing fasteners / jam nuts are torqued to manufacturer’s specification with calibrated torque wrench (note: fasteners should be marked upon being tensioned, once adjustment is completed, everything should be re-checked for correct tension)
                    </li>
                    <li>
                        Rocker cover / intermediate plate gasket replaced if required
                    </li>
                </ul>
                <strong style="display:block;margin-bottom:15px;">
                    Towed-In Vehicles, check/complete the following:
                </strong>
                <ul style="padding-left:15px;">
                    <li>
                        If tail shaft has been removed, ensure it is visually inspected, confirming that it is free of damage, in-phase and that fasteners installed correctly (see Tail Shaft Fitment list above)
                    </li>
                    <li>
                        If axle shafts have been removed, ensure correct remove and refit procedure has been carried out, including cleaning of surfaces and replacement of seals when required
                    </li>
                    <li>
                        If brake boosters have been unwound, ensure they are wound back into service position (brake roller test recommended upon completion if equipment is available)
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    Vue.component("app-footer", Footer);
    export default {
    }
</script>


// WEBPACK FOOTER //
// src/components/QC/TaskList.vue